import styled, { css } from 'styled-components';

import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export const PayButton = styled(BaseButton)<{ isOnlyBonuses: boolean }>`
    align-self: flex-start;
    ${({ isOnlyBonuses }) => isOnlyBonuses && css`
        color: ${COLORS.TextWhite};
        background-color: none;
        background: radial-gradient(63.45% 90.07% at 28.3% 105.36%, #ED3D3D 0%, rgba(237, 61, 61, 0) 100%),
                    linear-gradient(105.23deg, #B9CF31 15.62%, #FA00FF 106.65%);

        &:hover {
            background-color: none;
            background: radial-gradient(63.45% 90.07% at 28.3% 105.36%, #ED3D3D 0%, rgba(237, 61, 61, 0) 100%),
                    linear-gradient(105.23deg, #B9CF31 15.62%, #FA00FF 106.65%);
            opacity: .7;
        }
    `};

    @media (max-width: ${wideBreakpoints.mobile}) {
        align-self: auto;
    }
`;
